import { AppShell, Container } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { DevBanner } from 'components/layout/DevBanner'
import { Navbar } from 'components/layout/Navbar'
import { accountQuery } from 'hooks/auth'
import { useAppInfo } from 'hooks/info'
import { Account, RoleName } from 'types/auth'

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context: { queryClient }, location }) => {
    try {
      const account = await queryClient.ensureQueryData<Account>(accountQuery)
      return { account, isAdmin: account.roles.some((role) => role.name === RoleName.ADMIN) }
    } catch (error) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      })
    }
  },
  component: AuthLayout,
})

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

function AuthLayout() {
  const [opened, { toggle }] = useDisclosure()
  const { data } = useAppInfo()
  const showBanner = isLocalhost && data?.env === 'prod'

  return (
    <AppShell
      header={showBanner ? { height: 40 } : undefined}
      navbar={{
        width: 300,
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      {showBanner && (
        <AppShell.Header>
          <DevBanner />
        </AppShell.Header>
      )}
      <Navbar />
      <AppShell.Main>
        <Container px="lg" size="xl">
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  )
}
